/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCallRing = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m9.767 3.762.9 6.303-3.72 3.72a18.524 18.524 0 0 0 1.952 2.29l.442.429c.477.447.968.863 1.47 1.245l.378.28 3.72-3.721 6.304.9v5.525l-.293.293c-2.193 2.193-6.264 1.684-10.224-.91a20.123 20.123 0 0 1-2.83-2.254l-.38-.372a20.315 20.315 0 0 1-2.626-3.21c-2.595-3.96-3.103-8.032-.91-10.225l.293-.293zm5.85 12.667-2.69 2.691c2.521 1.362 4.825 1.638 6.144.832l.142-.093v-2.916zM8.032 5.762H5.117c-.918 1.29-.674 3.672.738 6.287l2.69-2.69zM13.017 6c2.761 0 4.977 2.243 4.977 5h-1.973c0-1.654-1.347-3-3.004-3zm0-4C17.987 2 22 6.037 22 11h-1.972c0-3.859-3.144-7-7.01-7z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCallRing as CallRing };
